import { CtgListData } from "@/components/business/CtgListContainer/ctgList.types";
import { ProcessStatusCode } from "@/types/code.types";
import { useCreateEntryDataMutation } from "@api/createEntryData/createEntryData";
import { DRAFT_STATUS_CODE } from "@constants/draftStatusCode.constants";
import { handleCtgError } from "@utils/handleDraftError";

import CtgStatus from "./components/CtgStatus/CtgStatus";

type Props = {
  data: CtgListData;
};

const CtgListStatusContainer = ({ data }: Props) => {
  const { mutateAsync: createEntryData } = useCreateEntryDataMutation();

  const checkDisabledStatusButton = (status: ProcessStatusCode) => {
    if (status !== DRAFT_STATUS_CODE.aiEntryDone) return false;
    return true;
  };

  const createDAE = (id: number) => {
    createEntryData(id);
  };

  return (
    <CtgStatus
      data={data}
      isDraftError={handleCtgError(data)[0]}
      draftErrorMessage={handleCtgError(data)[1]}
      createDAE={createDAE}
      disabled={checkDisabledStatusButton(data.draftArticleStatusHighest)}
    />
  );
};

export default CtgListStatusContainer;
